export enum UserPlan {
    NONE = "NONE",
    PROFESSIONAL = "PROFESSIONAL",
    ENTERPRISE = "ENTERPRISE",
}

export enum FeatureStatus {
    NEW = "NEW",
    BETA = "BETA",
}

export type SupportFeature = Readonly<{
    id: number
    progId: string
    name: string
    plan: UserPlan
    status?: FeatureStatus
    isEnabled: boolean
    children?: Array<SupportFeature>
}>

export type EditFeatureFormValues = Readonly<Omit<SupportFeature, "id" | "children">>

export type EditFeatureBody = Readonly<Omit<EditFeatureFormValues, "progId">>
